// extracted by mini-css-extract-plugin
module.exports = {"histories":"PurchaseHistories_histories__3Wmz4","tabAcceptance":"PurchaseHistories_tabAcceptance__25a-_"};